<template>
  <div class="filters u-absolute u-full-width u-bg-grey u-pad-y-sm u-pad-x-md">
    <div class="u-flex u-between u-middle u-marg-b-md">
      <p class="t-text--big">
        <img src="/images/filter.svg" alt="" class="u-inline-block u-marg-r-sm">
        <span class="u-white u-inline-block u-uppercase">Filter</span>
      </p>

      <button class="filters__btn-close t-button--simple u-relative" @click="onClose">
        <img src="/images/cross.svg" alt="" class="filters__btn-close__ico u-absolute u-w4of12">
      </button>
    </div>
    <div class="filters__row u-marg-b-xs">
      <p class="t-text--big u-white u-marg-b-sm">Filter by tag</p>
      <ul>
        <ul>
          <li v-for="tag in tags" class="u-inline-block u-marg-r-sm">
            <app-tag class="u-marg-b-sm" :content="tag" :is-btn="true" @toggle:tag="onToggleTag" />
          </li>
        </ul>
      </ul>
    </div>
    <div class="filters__row">
      <p class="t-text--big u-white u-marg-b-sm">Filter by content</p>
      <ul>
        <li class="u-inline-block u-marg-r-sm">
          <app-tag :content="{title:'PDF', id:'sbsPdf', sbsgradient: 'white'}" :is-btn="true" class="is-clear" @toggle:tag="onToggleTagType" />
        </li>
        <li class="u-inline-block u-marg-r-sm">
          <app-tag :content="{title:'PPT', id:'sbsPpt', sbsgradient: 'white'}" :is-btn="true" class="is-clear" @toggle:tag="onToggleTagType" />
        </li>
        <li class="u-inline-block u-marg-r-sm">
          <app-tag :content="{title:'Video', id:'sbsVideo', sbsgradient: 'white'}" :is-btn="true" class="is-clear" @toggle:tag="onToggleTagType" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppTag from '@/components/common/AppTag'

export default {
  components:
  {
    AppTag
  },

  props: {
    tags: {
      type: Array,
      default: null
    }
  },

  methods:
  {
    onClose () {
      this.$emit('close')
    },

    onToggleTag (isActive, tag) {
      this.$emit('toggle:tag', isActive, tag)
    },

    onToggleTagType(isActive, tag)
    {
      this.$emit('toggle:tagType', isActive, tag)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

  .filters
    top 0
    left 0
    border-radius 17px
    z-index 1
    transform translateZ(0)
    transition opacity .2s

    &-enter,
    &-leave-to
      opacity 0
      
  .filters__row
    transform translateZ(0)
    transition transform .6s ease-out-quint, opacity .4s

    &:last-child
      transition-delay .05s, .05s

    .filters-enter &
      opacity 0
      transform translateY(10px) translateZ(0)
    
  .filters__btn-close
    width 37px
    height 37px
    border-radius 50%
    box-shadow 0px 4px 20px rgba(255, 255, 255, 0.22)
    
    .filters__btn-close__ico
      top 50%
      left 50%
      transform translate(-50%, -50%)

</style>